module.exports = __webpack_public_path__ + "img/resource6.c5b330de.jpg";